'use strict';

import { swiffyslider } from 'swiffy-slider/dist/js/swiffy-slider.esm';
import { slideUp, slideDown, slideToggle } from "./functions.js";

window.swiffyslider = swiffyslider;

window.slideUp = slideUp;
window.slideDown = slideDown;
window.slideToggle = slideToggle;

document.addEventListener('DOMContentLoaded', () => {
  window.swiffyslider.init();

  const single = document.querySelector('.article, .versus');
  if(single) {
    let formData = new FormData();
    formData.append('action', 'views_counter');
    formData.append('id', single.getAttribute('data-id'));

    setTimeout(() => {
      fetch(themeVar.url, {
        method: 'POST',
        body: formData,
      });
    }, 1000);
  }

  let lazyImages = [].slice.call(document.querySelectorAll('img.lazy, source.lazy'));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          if(lazyImage.tagName.toLowerCase() == 'img') {
            lazyImage.src = lazyImage.dataset.src;
          } else {
            lazyImage.srcset = lazyImage.dataset.src;
          }
          lazyImage.classList.remove('lazy');
          if( lazyImage.classList.length == 0 ) {
            lazyImage.removeAttribute('class');
          }
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach((lazyImage) => {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    lazyImages.forEach((lazyImage) => {
      lazyImage.src = lazyImage.dataset.src;
      lazyImage.classList.remove('lazy');
      if( lazyImage.classList.length == 0 ) {
        lazyImage.removeAttribute('class');
      }
    });
  }

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
});
